import React from "react";
import PropTypes from "prop-types";
import { FiCheck } from "react-icons/fi";
import "./StepStatusIcon.scss";

/**
 * Indicador de estado de un paso (atom).
 *
 * Props:
 *  - status: "done" | "pending"
 *  - size: "sm" | "md" (default "md")
 *  - className: string
 *
 * En estado "pending" muestra un círculo vacío; en "done" un check que
 * aparece con una pequeña animación de aparición.
 */
const StepStatusIcon = ({ status = "pending", size = "md", className = "" }) => {
	const isDone = status === "done";

	return (
		<span
			className={`step-status step-status--${size} step-status--${
				isDone ? "done" : "pending"
			} ${className}`.trim()}
			aria-hidden="true"
		>
			{isDone && <FiCheck className="step-status__check" />}
		</span>
	);
};

StepStatusIcon.propTypes = {
	status: PropTypes.oneOf(["done", "pending"]),
	size: PropTypes.oneOf(["sm", "md"]),
	className: PropTypes.string,
};

export default StepStatusIcon;
